/**
 * @desc 根据仓库编码列表查询库位库存
 */
const URL = "/rantion-stock";
import http, { updateResponse } from "@/http";
export function request(body: defs.stock.StockSkuListQry, options?: any) {
  return updateResponse(
    http(URL + `/stock/getWarehouseSkuList`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
